import { Config, Layer, pipe } from "effect";
import { SecretSealerService } from "./sealing/SecretSealerService";
import { SecretUnsealerService } from "./unsealing";
const unsealerLayer = (config)=>pipe(Config.unwrap(config), SecretUnsealerService.layerConfigEncoded);
const sealerLayer = (config)=>pipe(Config.unwrap(config), Config.map(({ encodedSealingKey })=>encodedSealingKey), SecretSealerService.layerConfigEncoded);
export const layerConfigEncoded = (config)=>Layer.mergeAll(sealerLayer(config), unsealerLayer(config));
export const defaultEncoded = Layer.mergeAll(SecretSealerService.defaultEncoded, SecretUnsealerService.defaultEncoded);
